import React from 'react';
import ReactGA from 'react-ga4';

const Content = () => {
  return (
    <>
      <div className="popup-content-title">
        <h3>Mornington – Barkly Street</h3>
      </div>
      <div className="popup-content-source">
        <p>
          <span className="bold">
          We’re renewing the water main in Barkly Street, Mornington. 
          </span>
        </p>
        <p>
        Works will involve renewing the existing water main in Barkly Street from Empire to Herbert Street, Mornington.
        Our Industry Partner Beca, Fulton Hogan, Interflow Joint Venture (BFHI JV) plan to start construction mid-August 2026 for approximately 16 weeks (depending on the weather). 
        </p>
        <p>
          For more information contact the project team at{' '}
          <a href="tel:1800814900">1800 814 900</a> |{' '}
          <a
            href="mailto:renewals@sew.com.au"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              ReactGA.event({
                category: `Map - Major Projects (orange)`,
                action: 'Email link',
                label:
                  'MAIL TO: engagement@sew.com.au: Mornington - Barkley Street',
              });
            }}
          >
            renewals@sew.com.au
          </a>
        </p>
      </div>
    </>
  );
};

export default Content;
